import React from 'react';
import styles from './style.module.css';
import ContactForm from '../../components/forms/contact-coach';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Great work completing a Prosperity Plan!</p>
        <h1 className={styles.mainTitle}>Connect with a Coach</h1>
        <p className={styles.text}>Fill out the details below and we’ll connect you with a Libro Coach who can help you build a plan for the future.</p>
        <ContactForm/>
    </div>
);
